
export default {
  props: {
    value: {
      default: 0,
    },
    max: {
      default: 100,
    },
    extraStyle: {
      default: "",
    },
  },
};
